var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('allProduct',{attrs:{"genre":2,"classId":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }